import React from 'react';
import { useTheme } from '../context/ThemeContext';

const IntroductionCard = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className="intro-card">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-shrink-0">
          <div
            className="w-16 h-16 rounded-2xl flex items-center justify-center text-3xl"
            // style={{
            //   background: isDarkMode
            //     ? 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)'
            //     : 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            //   boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)'
            // }}
          >
            <span role="img" aria-label="medical">🩺</span>
          </div>
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Multilingual Medical Question Answering Analysis Dashboard
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            This dashboard provides comprehensive analysis of multilingual medical exam Q&A performance
            across different experimental settings. Compare <strong style={{ color: 'var(--monolingual-color)' }}>monolingual</strong>,
            {' '}<strong style={{ color: 'var(--multilingual-color)' }}>multilingual</strong>, and
            {' '}<strong style={{ color: 'var(--crosslingual-color)' }}>cross-lingual</strong> settings
            across various LLMs and languages (EN, ES, FR, IT, EU, KK).
            Use the filters below to explore performance trends, statistical analyses, and comparative insights.
          </p>
        </div>
      </div>

      {/* <div className="mt-4 pt-4 border-t" style={{ borderColor: 'var(--border-primary)' }}>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: 'var(--monolingual-color)', opacity: 0.9 }}
            >
              <span className="text-white text-lg">1</span>
            </div>
            <div>
              <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Monolingual</p>
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Same language training & testing</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: 'var(--multilingual-color)', opacity: 0.9 }}
            >
              <span className="text-white text-lg">N</span>
            </div>
            <div>
              <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Multilingual</p>
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Multiple language training</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: 'var(--crosslingual-color)', opacity: 0.9 }}
            >
              <span className="text-white text-lg">X</span>
            </div>
            <div>
              <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Cross-lingual</p>
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Transfer across languages</p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default IntroductionCard;
